/* eslint-disable import/prefer-default-export */
import * as ReactQuery from "@tanstack/react-query";
// Services
import * as Brm from "services/brm";

export const useGetThreatEventPatterns = (projectId, config = {}) => {
  return ReactQuery.useQuery({
    ...config,
    queryKey: ["threatEventPatterns", projectId],
    queryFn: () => Brm.threatEventPatternApi.findThreatEventPattern(projectId),
  });
};
